import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Mount once, near the top of the router tree, to force every route
 * navigation to start from `scrollY = 0`.
 *
 * Why: React Router doesn't reset scroll by default, so clicking
 * "Get Instant Quote" from the bottom of a product page leaves the
 * quote page scrolled to the same pixel offset — which looks broken
 * to customers who expect a fresh page to start at the top.
 *
 * Scope:
 *   - Fires on every `pathname` change (new route = new page).
 *   - Does NOT fire on `search`/`hash` changes — those represent
 *     within-page state (query params, anchor links) where keeping
 *     scroll position is the correct behavior.
 *   - Uses `instant` scroll (no smooth animation) to avoid the visible
 *     scroll-down-then-snap-back flash on already-scrolled pages.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // `window.scrollTo({ top: 0, behavior: 'instant' })` works in
    // modern browsers; older ones silently ignore `behavior` and still
    // scroll to (0,0) which is fine.
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname]);

  return null;
};

export default ScrollToTop;
